
import request from '@/utils/request'

//用户改约商家确认
export function shopConfirmUserAppoint(data) {
    return request({
        url: 'dzopen/shopConfirmUserAppoint',
        method: 'post',
        data
    })
}

//商家确认用户改约
export function shopConfirmUserChange(data) {
    return request({
        url: 'dzopen/shopConfirmUserChange',
        method: 'post',
        data
    })
}

//商家改约
export function shopChangeBook(data) {
    return request({
        url: 'dzopen/shopChangeBook',
        method: 'post',
        data
    })
}

//商家取消订单  
export function shopCancelBook(data) {
    return request({
        url: 'dzopen/shopCancelBook',
        method: 'post',
        data
    })
}

//更新订单状态（只能完成服务）
export function shopUpdateOrderStatus(data) {
    return request({
        url: 'dzopen/shopUpdateOrderStatus',
        method: 'post',
        data
    })
}



  